'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = responsive;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];

function extractValue(data, size) {
  if (Array.isArray(data)) {
    return data[sizes.indexOf(size)];
  }

  if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    return data[size];
  }

  return data;
}

function responsive(template, data) {
  return (0, _classnames2.default)(sizes.map(function (size) {
    var value = extractValue(data, size);
    if (value == null || value === false) {
      return '';
    }

    if (data === 'auto') {
      return template.replace(/#size.*$/, size);
    }

    return template.replace('#size', size).replace('#value', value);
  }));
}